export class SaveFilterPanelV2 {
  static readonly type = '[FilterPanelV2] Save';

  constructor(
    public panelKey: string,
    public values: any,
    public activeSectionKey: string | null,
    public hiddenSectionKeys: string[],
    public disabledSectionKeys: string[],
    public isCollapsed: boolean
  ) {}
}

export class ClearFilterPanelV2 {
  static readonly type = '[FilterPanelV2] Clear';

  constructor(public panelKey: string, public defaultValues: any) {}
}
